import React from "react";
import { Box } from "@mui/material";
import TutorAssignmentCard from "./TutorAssignmentCard";

const CARD_WIDTH = 250;

const TutorAssignmentCardRow = ({
  assignments,
  onView,
  onShare,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2.5,
      }}
    >
      {assignments.map((a) => (
        <Box key={a.id} sx={{ width: CARD_WIDTH }}>
          <TutorAssignmentCard
            a={a}
            onView={onView}
            onShare={onShare}
          />
        </Box>
      ))}
    </Box>
  );
};

export default TutorAssignmentCardRow;
